export default "__VITE_ASSET__cYpPn_BX__"